export const USER_LOGIN_ROUTE = "/login";
export const USER_SIGNUP_ROUTE = "/signup";
export const MAIN_SCREEN_ROUTE = "/main";
export const USER_ACTIONS_ROUTE = "/user";
export const USER_DELETE_ROUTE = "delete-user";
export const CHANGE_EMAIL_ROUTE = "change-email";
export const USER_PASSWORD_RESET_ROUTE = "/reset-password";
export const USER_PASSWORD_RESET_REQUEST_ROUTE = "request";
export const USER_PASSWORD_RESET_CONFIRM_ROUTE = "confirm/:token?";
